// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3dLkq","upload":"Small_upload__2YDzX","imageWrap":"Small_imageWrap__VPaob","removeBtn":"Small_removeBtn__3p77s"};